// extracted by mini-css-extract-plugin
module.exports = {"item":"SocialItem_item__Zrrmi"};